var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { attrs: { "no-border": "" } },
    _vm._l(_vm.mappedActivities, function(activity, index) {
      return _c(
        "q-item",
        { key: activity.id, attrs: { to: activity.url || undefined } },
        [
          _c(
            "q-item-side",
            { attrs: { left: "" } },
            [
              _vm.user(index)
                ? _c("user-avatar", { attrs: { user: _vm.user(index) } })
                : _vm._e()
            ],
            1
          ),
          _c("q-item-main", [
            _c("div", [
              _vm._v("\n        " + _vm._s(activity.title) + "\n        "),
              activity.tag
                ? _c("i", [
                    _vm._v("\n          " + _vm._s(activity.tag) + "\n        ")
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "activity-entry__subheadline" }, [
              _vm._v("\n        " + _vm._s(activity.description) + "\n      ")
            ])
          ]),
          _c(
            "q-item-side",
            { attrs: { right: "" } },
            [
              _c("q-item-tile", { attrs: { stamp: "" } }, [
                _vm._v(_vm._s(activity.timePassed))
              ])
            ],
            1
          )
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }